<template>
  <!-- 云盘 -->
  <div id="enterprise-cloud" v-if="enterpriseInfo">
    <div class="enterprise-cloud-type">
      <div class="enterprise-cloud-item">
        <div class="enterprise-cloud-item-title">
          <div class="catalogue">
            <div
              :class="{
                'catalogue-item': true,
              }"
              v-for="(item, index) in catalogue"
              :key="index"
            >
              <span @click="tipChange(item, index)">{{ item.name }}</span>
            </div>
          </div>
          <div class="enterprise-cloud-item-title-search">
            <div class="search-item">
              <el-input
                v-model="searchData.input"
                placeholder="请输入文件名称"
                @keyup.enter.native="queryFiles"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click.native.stop="queryFiles"
                ></el-button>
              </el-input>
            </div>
            <div v-if="editFlag" style="display: flex;">
              <div class="search-item">
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleClick('', 'rename')"
                  v-showFunction="{
                    active: 'reNameFile',
                    array: allFunctionButtons,
                  }"
                >
                  重命名
                </el-button>
              </div>
              <div class="search-item">
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleClick('', 'move')"
                  v-showFunction="{
                    active: 'moveFile',
                    array: allFunctionButtons,
                  }"
                >
                  移动
                </el-button>
              </div>
              <div class="search-item">
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleClick('', 'delete')"
                  v-showFunction="{
                    active: 'deleteFile',
                    array: allFunctionButtons,
                  }"
                >
                  删除
                </el-button>
              </div>
              <div class="search-item">
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleClick('', 'download')"
                  v-showFunction="{
                    active: 'downloadFile',
                    array: allFunctionButtons,
                  }"
                >
                  下载
                </el-button>
              </div>
            </div>
            <div v-else style="display: flex;">
              <div class="search-item">
                <el-upload
                  v-showFunction="{
                    active: 'addFile',
                    array: allFunctionButtons,
                  }"
                  multiple
                  class="avatar-uploader"
                  :action="upload.action"
                  :show-file-list="false"
                  :headers="upload.headers"
                  :data="upload.uploadParameter"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <el-button size="mini" type="primary">点击上传文件</el-button>
                </el-upload>
              </div>
              <div class="search-item">
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleClick('', 'addFolder')"
                  v-showFunction="{
                    active: 'addFolder',
                    array: allFunctionButtons,
                  }"
                  >新建文件夹</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="enterprise-cloud-item-value">
          <el-table
            :data="tableData"
            style="width: 100%"
            border
            :header-cell-style="{
              background: '#F5F7FA',
              color: '#111A34',
              fontWeight: 700,
            }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="35"></el-table-column>
            <el-table-column
              label="文件名"
              prop="name"
              show-overflow-tooltip
              min-width="200"
            >
              <template slot-scope="scope">
                <div class="file">
                  <i
                    v-if="scope.row.type == 0"
                    class="iconfont icon-folder"
                  ></i>
                  <img
                    v-else-if="
                      scope.row.fileType == 'jpg' || scope.row.fileType == 'png'
                    "
                    class="img"
                    :src="scope.row.uri"
                    v-viewer="{ movable: false }"
                  />
                  <img
                    v-else-if="
                      scope.row.fileType == 'doc' ||
                        scope.row.fileType == 'docx'
                    "
                    class="img"
                    src="../../assets/img/word.png"
                  />
                  <img
                    v-else-if="
                      scope.row.fileType == 'xlsx' ||
                        scope.row.fileType == 'xls'
                    "
                    class="img"
                    src="../../assets/img/excel.png"
                  />
                  <img
                    v-else-if="scope.row.fileType == 'pdf'"
                    class="img"
                    src="../../assets/img/pdf.png"
                  />
                  <div class="file-title" @click="linkFile(scope.row)">
                    {{ scope.row.name }}
                  </div>
                </div>
              </template>
              ></el-table-column
            >
            <el-table-column
              label="包含项"
              prop="includeItemsNum"
              show-overflow-tooltip
              min-width="100"
            />
            <el-table-column
              label="大小"
              prop="suitableSize"
              show-overflow-tooltip
              min-width="100"
            />
            <el-table-column
              label="更新人"
              prop="renewUserName"
              show-overflow-tooltip
              min-width="100"
            />
            <el-table-column
              label="更新时间"
              prop="gmtModified"
              show-overflow-tooltip
              min-width="100"
            />
            <el-table-column label="客户可见" prop="name">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.clientAppShow"
                  active-color="#13ce66"
                  :active-value="1"
                  :inactive-value="0"
                  :disabled="disabledFlag('visibleFile')"
                  @change="visibleFile($event, scope.row)"
                >
                </el-switch>
              </template>
              ></el-table-column
            >
          </el-table>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <div id="my-dialog" v-if="dialogData.flag">
      <my_dialog7
        :width="dialogData.width"
        :title="dialogData.title"
        :buttonArray="dialogData.buttonArray"
        :data="dialogData.data"
        :allFunctionButtons="allFunctionButtons"
        @colseDialog="colseDialog"
        @dialogOper="drawerOper"
      ></my_dialog7>
    </div>
  </div>
</template>

<script>
import enterpriseTable from "@/components/enterprise-components/enterprise-table";
import { initData } from "../../views/contract/js/contractData";
export default {
  components: {
    enterpriseTable,
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    tabActive: {
      type: Object,
      default: () => {},
    },
    enterpriseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      baseInfo: {},
      tableData: [],
      tempData: {},
      searchData: {
        input: "",
      },
      pageData: {
        // 分页参数
        currentPage: 1, // 当前页数
        total: 0, // 总条目数
        pageSize: 10, // 每页条数
      },
      dialogData: {
        flag: false,
        width: "30%",
        title: "新增档案",
        buttonArray: [
          {
            text: "确认",
            active: "confirm",
          },
        ],
        data: [],
      },
      catalogue: [{ name: "根目录", parent: "", id: "" }],
      allFunctionButtons: this.$featureData.getAllFunctionButtons("clientInfo"),
      upload: {
        flag: false,
        action: this.$fileBaseurl + "/uploadImageByMultipartFile",
        headers: {
          token: "95931b371eb64f4a9c862983ca8a5d15",
        },
        uploadParameter: {
          systemName: "finance",
          title: "客户云盘信息",
        },
      },
      multipleSelection: [],
      editFlag: false,
    };
  },
  methods: {
    getModelFeatureAuthority() {
      console.log("获取权限");
      this.$authority.getModelFeatureAuthority(
        this,
        "clientInfo",
        this.allFunctionButtons,
        (data) => {
          this.allFunctionButtons = data;
          this.initTableData();
          console.log("当前显示的按钮权限", data);
        },
      );
    },
    initTableData() {
      this.loading = true;
      let requestData = {
        clientId: this.clientInfo.id,
        parentId: this.catalogue[this.catalogue.length - 1].id, // 8aa9a7475a0d46a2a1a6224b37e87398
        clientAppShow: "", // 客户是否可见  '' 所有 0-客户不可见 1-客户可见
      };
      this.$request(
        "post",
        "/fileManage/query",
        requestData,
        (data) => {
          data.forEach((item) => {
            if (item.uri) {
              // 使用正则表达式匹配最后一个点后的文字
              let match = item.uri.match(/\.([^\.]+)$/);
              if (match && match[1]) {
                item.fileType = match[1];
              }
              item.uri = this.$fileBaseurl + "/" + item.uri;
            }
          });
          // 单独处理表格数据
          this.tableData = data;
          this.loading = false;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    handleClick(data, flag, batch) {
      this.tempData = data;
      let requestData = {};
      switch (flag) {
        // 新建文件夹
        case "addFolder":
          this.dialogData.title = "新建文件夹";
          this.dialogData.buttonArray = [
            {
              text: "确定",
              active: "make_sure_addFolder",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.dialogData.data = [
            {
              title: "文件夹名称",
              type: "input",
              value: "",
            },
          ];
          this.dialogData.flag = true;
          break;
        // 重命名
        case "rename":
          if (this.multipleSelection.length == 0) {
            return this.$message.error("请选勾选要操作的文件或文件夹");
          }
          if (this.multipleSelection.length > 1) {
            return this.$message.error("不允许批量编辑，请勾选一项");
          }
          let item = this.multipleSelection[0];
          let updatedText = "";
          if (item.type !== 0) {
            // 利用字符串切片获取最后一个点之前的部分
            updatedText = item.name.slice(0, item.name.lastIndexOf("."));
          } else {
            updatedText = item.name;
          }
          this.dialogData.title = "重命名文件夹";
          this.dialogData.buttonArray = [
            {
              text: "确定",
              active: "make_sure_reNameFile",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.dialogData.data = [
            {
              title: "文件夹名称",
              type: "input",
              value: updatedText,
            },
          ];
          this.dialogData.flag = true;
          break;
        // 移动
        case "move":
          if (this.multipleSelection.length == 0) {
            this.$message.error("请选勾选要操作的文件或文件夹");
            return;
          }
          this.dialogData.title = "移动文件";
          this.dialogData.buttonArray = [
            {
              text: "移动到此处",
              active: "make_sure_moveFile",
            },
          ];
          this.dialogData.data = [
            {
              type: "moveFile",
              data: {
                clientId: this.clientInfo.id, // 客户id
                targetFolderId: "", // 选中要移动的文件夹,
                multipleSelection: this.multipleSelection,
              },
            },
          ];
          this.dialogData.flag = true;
          break;
        // 删除
        case "delete":
          if (this.multipleSelection.length == 0) {
            this.$message.error("请选勾选要操作的文件或文件夹");
            return;
          }
          requestData = {
            ids: this.multipleSelection.map((item) => item.id),
            renewUserId: this.baseInfo.userId, // 进行更新操作的用户 id
          };
          this.$confirm("确定要删除该项数据吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$request(
                "post",
                "/fileManage/delBatch",
                requestData,
                (data) => {
                  this.$message.success("删除成功!");
                  this.initTableData();
                },
                (errorMessage) => {
                  this.$message.error(errorMessage);
                },
              );
            })
            .catch(() => {});
          break;
        // 下载
        case "download":
          // 下载文件或文件夹
          if (this.multipleSelection.length == 0) {
            return this.$message.error("请选勾选要操作的文件或文件夹");
          }
          requestData = {
            ids: this.multipleSelection.map((item) => item.id),
          };
          window.location.href =
            this.$baseurl +
            "/fileManage/download?params=" +
            JSON.stringify(requestData);
          break;
        default:
          break;
      }
    },
    drawerOper(active) {
      let requestData = {};
      switch (active) {
        // 确认新建文件夹
        case "make_sure_addFolder":
          // 确认新建文件夹
          requestData = {
            clientId: this.clientInfo.id, // 客户 id
            parentId: this.catalogue[this.catalogue.length - 1].id, // 父级目录 id
            name: this.dialogData.data[0].value.trim(), // 本级目录名称
            renewUserId: this.baseInfo.userId, // 进行更新操作的用户 id
          };
          this.$request(
            "post",
            "/fileManage/newFolder",
            requestData,
            (data) => {
              this.$message.success("新建成功");
              this.dialogData.flag = false;
              this.initTableData();
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        // 确认重命名
        case "make_sure_reNameFile":
          requestData = {
            clientId: this.clientInfo.id, // 客户 id
            id: this.multipleSelection[0].id, // 修改的目录或文件 id
            parentId: this.multipleSelection[0].parent, // 父级目录 id
            name: this.dialogData.data[0].value.trim(), // 新名称
            renewUserId: this.baseInfo.userId, // 进行更新操作的用户 id
          };
          this.$request(
            "post",
            "/fileManage/updateName",
            requestData,
            (data) => {
              this.$message.success("重命名成功!");
              this.dialogData.flag = false;
              this.initTableData();
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        // 确认移动
        case "make_sure_moveFile":
          requestData = {
            movingIdList: this.multipleSelection.map((item) => item.id), // 要移动的文件或文件夹 id 集合
            targetFolderId: this.dialogData.data[0].data.targetFolderId, // 目标文件夹 id
            renewUserId: this.baseInfo.userId, // 进行更新操作的用户 id
          };
          if (requestData.targetFolderId == "") {
            this.$message.error("请选择要移动的位置!");
            return;
          }
          this.$request(
            "post",
            "/fileManage/move",
            requestData,
            (data) => {
              this.$message.success("移动成功!");
              this.dialogData.flag = false;
              this.reSetFileOrder();
              this.initTableData();
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        case "cancel":
          this.colseDialog();
          break;
        default:
          break;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // 选中表格项 显示 上传文件 新建文件夹按钮  否则 显示重命名, 移动, 删除, 下载按钮
      if (val.length > 0) {
        this.editFlag = true;
      } else {
        this.editFlag = false;
      }
    },
    // 云盘 tip 目录点击
    tipChange(item, index) {
      console.log("item", item);
      console.log("index", index);
      if (index + 1 !== this.catalogue.length) {
        this.catalogue.splice(index + 1);
        this.initTableData();
      }
    },
    // 云盘
    linkFile(data) {
      console.log("data", data);
      if (data.type == 0) {
        // 文件夹
        this.catalogue.splice(data.level, 0, {
          name: data.name,
          id: data.id,
          parent: data.parent,
        });
        this.initTableData();
      } else {
        window.open(data.uri, "_blank");
      }
    },
    /**
     * 开启或关闭云盘内容可见
     */
    visibleFile(e, data) {
      let requestData = {
        id: data.id,
        clientAppShow: e,
      };
      this.$request(
        "post",
        "/fileManage/updateClientAppShow",
        requestData,
        (data) => {
          this.$message.success("编辑成功!");
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    disabledFlag(authorityKey) {
      let flag = true;
      this.allFunctionButtons.forEach((item) => {
        if (item.key == authorityKey && item.authority == "1") {
          flag = false;
        }
      });
      return flag;
    },
    queryFiles() {
      if (this.searchData.input == "") {
        this.initTableData();
        return;
      }
      this.loading = true;
      let requestData = {
        clientId: this.clientInfo.id,
        fileName: this.searchData.input, // 文件名
        clientAppShow: "", // 客户是否可见  '' 所有 0-客户不可见 1-客户可见
      };
      this.$request(
        "post",
        "/fileManage/queryFiles",
        requestData,
        (data) => {
          this.reSetFileOrder();
          data.forEach((item) => {
            if (item.uri) {
              // 使用正则表达式匹配最后一个点后的文字
              let match = item.uri.match(/\.([^\.]+)$/);
              if (match && match[1]) {
                item.fileType = match[1];
              }
              item.uri = this.$fileBaseurl + "/" + item.uri;
            }
          });
          this.tableData = data;
          this.loading = false;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    /**
     * 重置文件目录
     */
    reSetFileOrder() {
      this.catalogue = [{ name: "根目录", parent: "", id: "" }];
    },
    handleAvatarSuccess(response, file, fileList) {
      let dd = {
        mf: file.raw,
        name: file.name,
      };
      let fileUrlList = file.name.split(".");
      let imgType = ["jpg", "jpeg", "png"];
      if (imgType.indexOf(fileUrlList[fileUrlList.length - 1]) >= 0) {
        dd.type = "img";
      } else {
        dd.type = "text";
      }
      let formData = new FormData();
      formData.append("clientId", this.clientInfo.id);
      formData.append("renewUserId", this.baseInfo.userId);
      formData.append("parentId", this.catalogue[this.catalogue.length - 1].id);
      formData.append("name", dd.name);
      formData.append("mf", dd.mf);
      this.$requestByFormData(
        "post",
        "/fileManage/newFile",
        formData,
        (data) => {
          this.$message.success("上传成功!");
          this.dialogData.flag = false;
          this.initTableData();
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    beforeAvatarUpload(file) {
      console.log("上传文件格式:", file);
      let isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过!");
      }
      return isLt2M;
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.getModelFeatureAuthority();
  },
};
</script>

<style lang="less" scoped>
#enterprise-cloud {
  width: 100%;
  background-color: #fff;
  .enterprise-cloud-type {
    width: 100%;
    .enterprise-cloud-item {
      width: 100%;
      margin-top: 32px;
      scroll-margin-top: 180px;
      &:first-child {
        margin-top: 0;
      }

      .enterprise-cloud-item-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        .catalogue {
          display: flex;
          .catalogue-item {
            color: #409eff;
            cursor: pointer;
            &::after {
              content: ">";
              color: #409eff;
              cursor: default;
              margin: 5px;
            }
            // 取消最后一个 after
            &:last-child::after {
              content: "";
            }
            &:last-child {
              color: #777e95;
              cursor: default;
            }
          }
        }
        .enterprise-cloud-item-title-search {
          display: flex;
          .search-item {
            margin-left: 5px;
          }
        }
      }
      .enterprise-cloud-item-tag {
        display: flex;
        margin: 12px 0;
        .tag {
          font-size: 14px;
          color: #777e95;
          cursor: pointer;
          height: 28px;
          padding: 0 12px;
          line-height: 28px;
          cursor: pointer;
          border-radius: 14px;
        }
        .is-active {
          color: #327bf9;
          background: #eaf2ff;
        }
        .is-disabled {
          color: #c3c8da;
          cursor: not-allowed;
        }
      }
      .enterprise-cloud-item-value {
        width: 100%;
        .icon-folder {
          font-size: 30px;
        }
        .img {
          width: 30px;
          height: 30px;
        }
        .file {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .file-title {
            color: #7db1fe;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
